import React from 'react'

function Skills() {
  return (
    <>
      <div id="Skills" className='py-20'>
        <div className="Skills-Section">
          <h2 data-aos="zoom-in-down" className='pt-10'>My <span>Skills</span>.</h2>
          <p data-aos="zoom-in-down">Here is information about my Skills in Front-End Development.</p>
        </div>

        <div className="Skills-Icons mt-24">
          <div className="Basic-Section" data-aos="zoom-in">
            <div className="html-Section" data-aos="zoom-in-up">
              <span className="Span-Icon"><i className='bx bxl-html5' ></i></span>
              <h2 className='font-bold text-2xl'>HTML <span>.</span></h2>
              <p>Language for structuring web content, including text, images, and multimedia.</p>
            </div>
            <div className="html-Section" data-aos="zoom-in-up">
              <span className="Span-Icon"><i className='bx bxl-css3' ></i></span>
              <h2 className='font-bold text-2xl'>CSS <span>.</span></h2>
              <p>Styles web content, defining layout, colors, fonts, and visual presentation.</p>
            </div>
            <div className="html-Section" data-aos="zoom-in-up">
              <span className="Span-Icon"><i className='bx bxl-bootstrap' ></i></span>
              <h2 className='font-bold text-2xl'>BootStrap <span>.</span></h2>
              <p>Frontend framework simplifying web development with pre-designed components and utilities.</p>
            </div>
            <div className="html-Section" data-aos="zoom-in-up">
              <span className="Span-Icon"><i className='bx bxl-tailwind-css'></i></span>
              <h2 className='font-bold text-2xl'>TailWindCSS <span>.</span></h2>
              <p>Utility-first CSS framework streamlining web design with reusable utility classes.</p>
            </div>
          </div>


          <div className="Rare-Section">
            <div className="JS-Section" data-aos="zoom-in-up">
              <div className="JS-Section" data-aos="zoom-in-up">
                <span className="Span-Icon"><i className='bx bxs-bolt-circle'></i></span>
                <h2 className='font-bold text-2xl'>Chakra UI <span>.</span></h2>
                <p>React library for creating accessible, customizable, and responsive user interfaces.</p>
              </div>
              <span className="Span-Icon"><i className='bx bxl-javascript' ></i></span>
              <h2 className='font-bold text-2xl'>JavaScript <span>.</span></h2>
              <p>Programming language that enables dynamic behavior and interactivity in web applications.</p>
            </div>
            <div className="JS-Section" data-aos="zoom-in-up">
              <span className="Span-Icon"><i className='bx bxl-react' ></i></span>
              <h2 className='font-bold text-2xl'>React <span>.</span></h2>
              <p>JavaScript library for building user interfaces with reusable components and state management.</p>
            </div>
            <div className="JS-Section" data-aos="zoom-in-up">
              <span className="Span-Icon"><i className='bx bxl-nodejs' ></i></span>
              <h2 className='font-bold text-2xl'>NodeJS <span>.</span></h2>
              <p>JavaScript runtime environment executing code outside the browser for server-side applications.</p>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Skills
